import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { Loader } from 'is24-corecss';
import styles from './PageWrapper.module.css';
import { ToastContainer } from 'react-toastify';

const PageWrapper = ({ children }: { children: JSX.Element }) => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    <div className="border-top margin-top-s padding-top-s">
      <>
        <ToastContainer
          autoClose={10_000}
          position="top-right"
          draggable={false}
          closeButton={false}
          hideProgressBar={true}
        />
        {promiseInProgress ? (
          <div className={styles.overlay} id={'ss_loader'}>
            <Loader />
          </div>
        ) : (
          children
        )}
      </>
    </div>
  );
};

export { PageWrapper };
